import { Dialog, DialogContent } from '@commenda/kakashi';
import { DirectorBase } from '@commenda/types/src/incorporation/types';
import { TSetNotification } from '@commenda/types/src/random';
import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { IncorporationRequestDataType } from '@commenda/types';
import React, { useState } from 'react';
import { KeyedMutator } from 'swr';
import { DirectorFormType } from '../DirectorFormType';
import { CorporationForEmailValidation } from '../../../common/helpers';

const DirectorModal = ({
  isOpen,
  setOpen,
  companyDataMutate,
  DirectorForm,
  corporationId,
  selectDirectorById,
  setNotification,
  companyId,
  token,
  director,
  selectedDirectorIds,
  setSelectedDirectorIds,
  modalConfig,
  allCorporations,
  workRequestData,
}: {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  companyDataMutate?: KeyedMutator<unknown>;
  DirectorForm: DirectorFormType<DirectorBase>;
  corporationId?: number;
  selectDirectorById?: (directorId: number) => void;
  setNotification: TSetNotification;
  companyId: number;
  token: string;
  director?: DirectorBase;
  selectedDirectorIds?: number[];
  setSelectedDirectorIds?: React.Dispatch<React.SetStateAction<number[]>>;
  modalConfig?: {
    heading?: string;
    subheading?: string;
    dialogTitle?: string;
    isDirector?: boolean;
    postSave?: (director: {
      id: number;
      directorFirstName: string;
      directorLastName: string;
    }) => void;
  };
  allCorporations?: CorporationForEmailValidation[]; // For cross-entity email validation
  workRequestData?: WorkRequestResponseType & { requestData: IncorporationRequestDataType };
}) => {
  const [isAddingDirector, setIsAddingDirector] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent
        className="max-h-[85vh] px-0 py-0 overflow-hidden"
        preventCloseOnOutsideClick
      >
        <DirectorForm
          companyDataMutate={companyDataMutate}
          isAddingDirector={isAddingDirector}
          setIsAddingDirector={setIsAddingDirector}
          setOpen={setOpen}
          corporationId={corporationId}
          selectDirectorById={selectDirectorById}
          setNotification={setNotification}
          companyId={companyId}
          token={token}
          director={director}
          selectedDirectorIds={selectedDirectorIds}
          setSelectedDirectorIds={setSelectedDirectorIds}
          modalConfig={modalConfig}
          allCorporations={allCorporations}
          workRequestData={workRequestData}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DirectorModal;
